import withStyles from "@material-ui/core/styles/withStyles";
import { alpha } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { animated, useSpring } from "react-spring/web.cjs";
import React from "react";
import PropTypes from "prop-types";
import TreeItem from "@material-ui/lab/TreeItem";

function TransitionComponent(props) {
    const style = useSpring({
        from: { opacity: 0, transform: "translate3d(20px,0,0)" },
        to: {
            opacity: props.in ? 1 : 0,
            transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
        },
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
}

TransitionComponent.propTypes = {
    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes.bool,
};

export const EATreeItem = withStyles((theme) => ({
    iconContainer: {
        "& .leaf": {
            width: 15,
            marginTop: 1,
            borderBottom: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
        },
    },
    label: {
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    group: {
        marginLeft: 7,
        paddingLeft: 0,
        borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
}))((props) => {
    const title = {};
    if (props.label && !props.title) {
        title.title = props.label;
    }
    return <TreeItem {...title} {...props} TransitionComponent={TransitionComponent} />;
});
